export enum SortByOption {
	Default = 'Default',
	TestName = 'TestName',
	LastTested = 'LastTested',
	ContentArea = 'ContentArea',
	NumberOfQuestions = 'NumberOfQuestions',
}
